import { CODES, KEYS } from "@excalidraw/common";

import { CaptureUpdateAction } from "@excalidraw/element";

import { PresentationIcon } from "../components/icons";

import { register } from "./register";

// PizzarWeb: presentation mode reduces the toolbar to a few annotation tools
// and hides the rest of the UI for a clean live-presenting view.
export const actionTogglePresentationMode = register({
  name: "presentationMode",
  label: "labels.presentationMode",
  icon: PresentationIcon,
  viewMode: true,
  trackEvent: {
    category: "canvas",
    predicate: (appState) => !appState.presentationModeEnabled,
  },
  // Enter-only: turning presentation mode OFF is handled by the app so it can
  // show the "your changes will be lost" modal first.
  perform(elements, appState) {
    return {
      appState: {
        ...appState,
        presentationModeEnabled: true,
      },
      captureUpdate: CaptureUpdateAction.EVENTUALLY,
    };
  },
  checked: (appState) => appState.presentationModeEnabled,
  predicate: (elements, appState) => !appState.presentationModeEnabled,
  keyTest: (event, appState) =>
    !appState.presentationModeEnabled &&
    !event[KEYS.CTRL_OR_CMD] &&
    event.altKey &&
    event.code === CODES.P,
});
